import type { FunctionComponent } from 'react';
import { Button } from '@fff-web/fff-ui-shared';
import { useReactivateMyMembershipContext } from '../../../utils/ContextProviders/ReactivateContext';
import { ReactivateMembershipVariablesType } from '../../../utils/ContextProviders/ReactivateContext/defaultReactivateMyMembershipContext';
import * as styles from './HeroBanner.module.scss';

type HeroBannerContainerProps = {
  onCTAClick: () => void;
};

interface TextHeroBannerProps {
  headline: string;
  caption: string;
  primaryCTA: string;
  disclaimer: string;
  onClickPrimaryCTA: () => void;
}

export const TextHeroBanner = ({
  headline,
  caption,
  primaryCTA,
  disclaimer,
  onClickPrimaryCTA,
}: TextHeroBannerProps) => {
  return (
    <section className={styles.wrapperHero}>
      <h1 className={styles.headline}>{headline ?? ''}</h1>
      <h2 className={styles.caption}>{caption ?? ''}</h2>
      <p className={styles.disclaimer}>{disclaimer ?? ''}</p>
      <div className={styles.buttonWrapper}>
        <Button onClick={onClickPrimaryCTA}>{primaryCTA}</Button>
      </div>
    </section>
  );
};

const HeroBannerContainer: FunctionComponent<HeroBannerContainerProps> = ({ onCTAClick }) => {
  const { growthMyMembership } = useReactivateMyMembershipContext();
  const { heroBanner } = growthMyMembership?.variables as ReactivateMembershipVariablesType;
  const { headline, caption, disclaimer, primaryCTA } = heroBanner;

  return (
    <TextHeroBanner
      headline={headline.text}
      caption={caption.text}
      disclaimer={disclaimer.text}
      primaryCTA={primaryCTA.label}
      onClickPrimaryCTA={onCTAClick}
    />
  );
};

export default HeroBannerContainer;
